import { environment } from "./../../../../../environments/environment";
import { HttpHeaders, HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class EmailService {
  private baseUrlService: string;
  private baseUrlParametros: string;
  private baseUrlParamTeste: string;
  private baseUrlSelect: string;
  private baseUrlDelete: string;

  constructor(private http: HttpClient) {
    this.baseUrlService = environment.URL_API + "/autenticacao/cadastrarEmail";
    this.baseUrlParametros = environment.URL_API + "/autenticacao/parametrosDeSeguranca";
    this.baseUrlParamTeste = environment.URL_API + "/autenticacao/testeDeEmail";
    this.baseUrlSelect = environment.URL_API + "/autenticacao/telaParametros";
    this.baseUrlDelete = environment.URL_API + "/autenticacao/retirarAcesso";
  }

  cadastroEmail(username: string, password: string, host: string, port: number, authentication: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: JSON.parse(sessionStorage.getItem("currentUser")).token,
    });
    const httpOptions = { headers: headers };
    const body = `&username=${username}&password=${password}&host=${host}&port=${port}&authentication=${authentication}`;

    return this.http.post(this.baseUrlService, body, httpOptions).toPromise();
  }

  salvarParametroSeguranca(body: Object) {
    const token = JSON.parse(sessionStorage.getItem('currentUser')).token;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': token
    });

    return this.http.post<any>(this.baseUrlParametros, body, { headers }).toPromise();
  }

  testarParametrosEmail(username: string, password: string, host: string, port: number, authentication: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: JSON.parse(sessionStorage.getItem("currentUser")).token,
    });
    const httpOptions = { headers: headers };
    const body = `&username=${username}&password=${password}&host=${host}&port=${port}&authentication=${authentication}`;

    return this.http.post(this.baseUrlParamTeste, body, httpOptions).toPromise();
  }

  getTelaParam() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: JSON.parse(sessionStorage.getItem("currentUser")).token,
    });
    const httpOptions = { headers: headers };
    return this.http.get<any>(this.baseUrlSelect, httpOptions);
  }

  retirarAcesso() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: JSON.parse(sessionStorage.getItem("currentUser")).token,
    });
    const httpOptions = { headers: headers };
    return this.http.post(this.baseUrlDelete, httpOptions).toPromise();
  }
} 
